import { Field } from 'react-final-form';
import React from 'react';


const TimeSlots = props => {
    return (
        <div className="slot-block">
            <h5 className="text-uppercase fsp14 fw500 mr-b10">Pick Your Time</h5>
            <div className="time-selector">
                {props.slots.map((slot, index) => {
                    return (
                        <div key={slot.slot_id} onClick={() => props.mutators.setSlotName(slot.slot_name, true)}><Field className={`block mr-b8 mr-t8 time_${index}`} name="slot" type="radio" value={`${slot.slot_id}`} component={props.Radio}>{slot.slot_name}</Field></div>
                    );
                })}
            </div>
        </div>
    );
  };

export default TimeSlots;
